export default __webpack_public_path__ + "static/media/272.a8146adc.gif";